import React, { useState, useEffect } from 'react';

import ImgModal from '../../components/ImgModal/ImgModal';
import s from './Good.module.scss';

const ImageGallery = props => {
  const { imagesArr, t } = props;
  const [indexImg, setIndexImg] = useState(0);

  useEffect(() => {
    setIndexImg(0);
  }, [imagesArr]);
  if (!imagesArr.length) return null;
  return (
    <div className={s.images}>
      <div className={s.preview}>
        {imagesArr.map((i, index) => (
          <div key={index} onClick={() => setIndexImg(index)}>
            <img src={i.src} alt={i.alt} title={i.title} />
          </div>
        ))}
      </div>
      <div className={s.mainImg}>
        <ImgModal image={imagesArr[indexImg]} />
        <p className="note-face-device">
          {t['Внешний вид товара может отличаться от представленного на сайте']}
        </p>
      </div>
    </div>
  );
};

export default ImageGallery;
